module.exports = __webpack_public_path__ + "static/media/phi.5ebd06cd.png";